import { pipe } from 'fp-ts/lib/function';
import { lookup } from 'fp-ts/lib/ReadonlyRecord';

export const translationMap = {
  OresundGO: 'oresundGo',
  OresundPendler: 'oresundCommuter',
  Oresund_Business_Pendler: 'oresundBusinessCommuter',
  Oresund_Business: 'oresundBusiness',
  OresundPAY: 'oresundPay',
  OresundPAYBusiness: 'oresundPayBusiness',
  Storebelt: 'storebelt',
  OresundPeriodCard: 'oresundPeriodCard',
} as const;

export type TranslateableContracts = keyof typeof translationMap;
export type ContractTranslationKey =
  typeof translationMap[TranslateableContracts];

export const getContractTranslationKey = (contract: TranslateableContracts) =>
  pipe(translationMap, lookup(contract));
